// 屏幕适配基础配置项目
// export const CACHE_CUSTOM_INSTANCE_ID = 'CACHE_INSTANCE_ID_' + Date.now();

// widthParam与heightParam为checksize所需宽高比，不传则为崩坏3webview活动带顶栏的比例
// 常用比例：
// 崩2 16：9
// 崩3全屏 16：9
// 崩3小窗 & 崩3带顶栏 659：336 （不传即可）

export default {
  // 崩坏2默认就只有全屏
  BH2_FULLSCREEN: {
    widthParam: 16,
    heightParam: 9
  },
  
  // 崩坏3默认是带顶部工具栏
  BH3_TOOLBAR: {
    widthParam: 659,
    heightParam: 336
  },

  // 崩坏3全屏模式打开
  BH3_FULLSCREEN: {
    widthParam: 16,
    heightParam: 9
  },

  // 崩坏3小窗嵌入模式打开
  BH3_EMBEDDED: {
    widthParam: 659,
    heightParam: 336
  }
}